import ContentStoreFactory from '@icare/sitecore-content/lib/ContentStoreFactory';
import {CONTENT_API_BASE, VIRTUAL_PAGE_API_BASE} from '~/config';

export const ContentStore = ContentStoreFactory.createContentStore(
	CONTENT_API_BASE,
	VIRTUAL_PAGE_API_BASE,
);

export default ContentStore;
